import React, { PureComponent } from "react";
import styled from 'styled-components';
import { Loader } from "react-loaders";

import { patchRequest, deleteRequest, postRequest } from '../../../api/ApiService';
import { isSurveyFinished, isSurveyStarted } from '../../../api/Surveys';
import Auth from '../../../routes/Auth';

import TeamRolesSelector from './selector';

import CheckedIcon from '../../../containers/assets/icon-teams-roles-checked.svg';
import UncheckedIcon from '../../../containers/assets/icon-teams-roles-unchecked.svg';
import EditIcon from '../../../containers/assets/icon-teamplayers-edit.svg';

import SurveyPogressCompletedIcon from '../../../containers/assets/icon-team-survey-progress-completed.svg';
import SurveyPogressIncompleteIcon from '../../../containers/assets/icon-team-survey-progress-incomplete.svg';
import SurveyPogressInProgressIcon from '../../../containers/assets/icon-team-survey-progress-in-progress.svg';
import SurveyPogressNotStartedIcon from '../../../containers/assets/icon-team-survey-progress-not-started.svg';

import { teamPlayerRoles } from './../../constants';

const Table = styled.table`
  width: 100%;
  font-family: 'Mukta Vaani';
  font-size: 14px;
  border-top: 1px solid #DEE0E3;
`;

const TableHeadRow = styled.tr`
  background: #F5F6F7;
  box-shadow: inset 0px -1px 0px #DEE0E3;
`;

const TableHeadCell = styled.th`
  padding: 16px;
  line-height: 16px;
  font-weight: 700 !important;
  position: relative;
  
  &:after {
    display: block;
    content: '';
    width: 1px;
    height: 16px;
    background: #CED1D6;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
  }

  &:last-child:after {
    display: none;
  }

  ${p => p.withSelector && `
    width: 155px;
  `}
  
  ${p => p.withActions && `
    width: 180px;
  `}
`;

const TableRow = styled.tr`
  box-shadow: inset 0px -1px 0px #ECEDEF;

  &:nth-child(2n-1) {
    background: #FAFBFD;
  }

  ${p => p.activeRow && `
    background: #EBF2FF !important;
  `}
`;

const TableCell = styled.td`
  padding: 12px 16px;

  ${p => p.withActions && `
    display: flex;
  `}
`;

const RoleBadge = styled.div`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 16px;
  line-height: 20px;
  font-weight: 500;
  border: 1px solid;
  text-align: center;

  ${p => (p.role && p.role === 'CEO') && `{
    color: #ECA427;
    border-color: #ECA427;
    background: #FFF8EB;
  }`}}

  ${p => (p.role && p.role === 'PD') && `{
    color: #55B4BC;
    border-color: #55B4BC;
    background: #ECF6F7;
  `}}
  
  ${p => (p.role && p.role === 'PM') && `{
    color: #5C91F5;
    border-color: #5C91F5;
    background: #EBF2FF;
  `}}
  
  ${p => (p.role && p.role === 'OP') && `{
    color: #EC5E59;
    border-color: #EC5E59;
    background: #FAEDED;
  `}}
  
  ${p => (p.role && p.role === 'FI') && `{
    color: #9B77FF;
    border-color: #A98DF6;
    background: #F4F1FA;
  `}}
`;

const RegisteredIcond = styled.img`
  width: 15.75px;
  height: 15.75px;
`;

const TableButton = styled.button`
  border: 2px solid #D5D9DD;
  border-radius: 4px;
  line-height: 20px;
  font-weight: 500;
  color: rgba(0, 27, 59, 0.6);

  ${p => p.saveButton && `
    background: #5C91F5;
    border-color: #5C91F5;
    color: #fff;
    margin-left: 8px;
  `}
`;

const EditButtonIcon = styled.img`
  width: 12px;
  height: 12px;
  margin-right: 6px;
`;

const ButtonLoader = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  > .loader {
    margin-top: 0 !important;
    margin-left: 0 !important;

    .loader-inner div {
      width: 15px;
      height: 15px;
      border-color: #fff !important;
    }
  }
`;

const SurveyStatusWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const SurveyStatusIcon = styled.div`
  width: 18px;
  height: 18px;

  img {
    width: 100%;
    height: 100%;
  }
`;

const SurveyProgressTextsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 8px;
`;

const SurveyProgressText = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #282A2E;

  
  ${p => (p.status && p.status === 'Not Started') && `{
    color: rgba(0, 27, 59, 0.38);
  `}}
`;

const SurveyProgressStatusText = styled.div`
  color: rgba(0, 27, 59, 0.6);
  font-size: 12px;
  line-height: 14px;

  ${p => (p.status && p.status === 'Closed') && `{
    color: rgba(0, 27, 59, 0.38);
  `}}
`;

const NameCellContent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const TrashButton = styled.button`
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #EC5E59;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  &:hover {
    background: #FAEDED;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

const ConfirmOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ConfirmModal = styled.div`
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  padding: 32px;
  max-width: 480px;
  width: 90%;
  font-family: 'Mukta Vaani';
`;

const ConfirmTitle = styled.h3`
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  margin: 0 0 16px;
`;

const ConfirmMessage = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.8);
  margin: 0 0 24px;
`;

const ConfirmError = styled.p`
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #C62828;
  margin: 0 0 16px;
`;

const ConfirmActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

const ConfirmCancelButton = styled.button`
  background: #F5F6F7;
  border: 1px solid #D5D9DD;
  border-radius: 4px;
  padding: 8px 20px;
  font-family: 'Mukta Vaani';
  font-weight: 500;
  font-size: 14px;
  color: rgba(0, 27, 59, 0.8);
  cursor: pointer;
`;

const ConfirmProceedButton = styled.button`
  background: #EC5E59;
  border: none;
  border-radius: 4px;
  padding: 8px 20px;
  font-family: 'Mukta Vaani';
  font-weight: 500;
  font-size: 14px;
  color: #fff;
  cursor: pointer;

  &:hover {
    background: #d44a45;
  }

  &:disabled {
    background: #f0a5a2;
    cursor: not-allowed;
  }
`;

const TrashIconSvg = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const RoleHeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SortableHeader = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  font-weight: 700;
  color: inherit;
  cursor: pointer;
`;

const SortIconWrapper = styled.span`
  display: inline-flex;
  flex-direction: column;
  gap: 1px;
  line-height: 0;
`;

const SortChevron = styled.span`
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  opacity: ${p => p.active ? 1 : 0.35};

  ${p => p.direction === 'up' && `
    border-bottom: 5px solid ${p.active ? '#55B4BC' : 'rgba(0, 27, 59, 0.6)'};
  `}
  ${p => p.direction === 'down' && `
    border-top: 5px solid ${p.active ? '#55B4BC' : 'rgba(0, 27, 59, 0.6)'};
  `}
`;

const RotateButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #55B4BC;
  cursor: ${p => p.disabled ? 'not-allowed' : 'pointer'};
  opacity: ${p => p.disabled ? 0.35 : 1};

  &:hover {
    background: ${p => p.disabled ? 'transparent' : '#ECF6F7'};
  }

  svg {
    width: 16px;
    height: 16px;
    stroke: currentColor;
    animation: ${p => p.spinning ? 'rotateSpin 900ms linear infinite' : 'none'};
  }

  @keyframes rotateSpin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;

const RotateIconSvg = () => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 4 23 10 17 10" />
    <polyline points="1 20 1 14 7 14" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10" />
    <path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14" />
  </svg>
);

class TeamsRolesTable extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      activeEditedRow: 0,
      activeEditedTeamId: 0,
      activeEditedRole: null,
      editedRowChanged: false,
      saveButtonLoading: false,
      memberToDelete: null,
      deleteLoading: false,
      deleteError: null,
      rotatingRoles: false,
      teamSortDirection: null,
    };
  }

  handleTeamSortToggle = () => {
    const { teamSortDirection } = this.state;
    const next = teamSortDirection === null
      ? 'asc'
      : teamSortDirection === 'asc'
        ? 'desc'
        : null;
    this.setState({ teamSortDirection: next });
  };

  handleRotateRoles = () => {
    if (this.state.rotatingRoles) return;
    const gameId = Auth.getGameId();
    if (!gameId) return;

    this.setState({ rotatingRoles: true });

    postRequest(`${process.env.REACT_APP_API_URL}v2/games/rotate-roles/`)
      .send({ game_id: gameId })
      .then(() => {
        this.setState({ rotatingRoles: false });
        const { onRotateComplete } = this.props;
        if (onRotateComplete) onRotateComplete();
      })
      .catch(() => {
        this.setState({ rotatingRoles: false });
      });
  };

  handleTrashClick = (courseMemberId, teamPlayerId, name) => {
    this.setState({
      memberToDelete: { courseMemberId, teamPlayerId, name },
      deleteError: null
    });
  };

  handleCancelDelete = () => {
    this.setState({ memberToDelete: null, deleteError: null, deleteLoading: false });
  };

  handleConfirmDelete = () => {
    const { memberToDelete } = this.state;
    if (!memberToDelete) return;

    this.setState({ deleteLoading: true, deleteError: null });

    deleteRequest(
      `${process.env.REACT_APP_API_URL}course_members/${memberToDelete.courseMemberId}/`
    )
      .then(() => {
        const { teamPlayers, changeTeamPlayers } = this.props;
        const updatedTeamPlayers = teamPlayers.filter(tp => tp.id !== memberToDelete.teamPlayerId);
        changeTeamPlayers(updatedTeamPlayers);

        this.setState({
          memberToDelete: null,
          deleteLoading: false,
          deleteError: null,
          activeEditedRow: 0,
          activeEditedTeamId: 0,
          activeEditedRole: null
        });
      })
      .catch(err => {
        this.setState({
          deleteLoading: false,
          deleteError: 'Failed to remove student. Please try again.'
        });
      });
  };

  handleTeamPlayerButtonClick = (teamPlayerId, teamId, role) => {
    this.setState({
      activeEditedRow: teamPlayerId,
      activeEditedTeamId: teamId,
      activeEditedRole: role
    });
  };

  handleTeamSelectChange = (value) => {
    this.setState({
      editedRowChanged: true,
      activeEditedTeamId: value
    })
  }

  handleRoleSelectChange = (value) => {
    this.setState({
      editedRowChanged: true,
      activeEditedRole: value
    })
  }

  handleSaveButtonClick = (teamPlayerId, teamId, role) => {
    this.setState({
      saveButtonLoading: true
    });

    patchRequest(
      `${process.env.REACT_APP_API_URL}v2/games/teamplayers/${teamPlayerId}/`
    )
      .send({
        team: teamId,
        role: role
      })
      .then(res => {
        const { teamPlayers, changeTeamPlayers } = this.props;

        const updatedTeamPlayers = teamPlayers.map(teamPlayer => teamPlayer.id === teamPlayerId ? { ...teamPlayer, team: teamId, role: role } : teamPlayer);
        changeTeamPlayers(updatedTeamPlayers);

        this.setState({
          saveButtonLoading: false,
          activeEditedRow: 0,
          activeEditedTeamId: 0,
          activeEditedRole: null
        });
      })
      .catch(err => {
        this.setState({
          saveButtonLoading: false
        });
      });
  }

  render() {
    const {
      teamPlayers,
      courseMembers,
      availableTeams,
      surveys,
      surveysFeedbacks
    } = this.props;

    const {
      activeEditedRow,
      activeEditedTeamId,
      activeEditedRole,
      editedRowChanged,
      saveButtonLoading,
      memberToDelete,
      deleteLoading,
      deleteError,
      rotatingRoles,
      teamSortDirection
    } = this.state;

    const anyRoleAssigned = teamPlayers.some(tp => tp && tp.role);
    const rotateDisabled = !anyRoleAssigned || rotatingRoles;

    const teamDisplayName = (tp) => {
      const mapped = availableTeams && availableTeams[' ' + Number(tp.team)];
      return mapped != null ? String(mapped) : String(tp.team || '');
    };

    const sortedTeamPlayers = teamSortDirection
      ? [...teamPlayers].sort((a, b) => {
          const cmp = teamDisplayName(a).localeCompare(
            teamDisplayName(b),
            undefined,
            { numeric: true, sensitivity: 'base' }
          );
          return teamSortDirection === 'asc' ? cmp : -cmp;
        })
      : teamPlayers;

    const surveysStatuses = surveys.map(survey =>
      isSurveyFinished(survey)
        ? 'Closed'
        : isSurveyStarted(survey)
          ? 'Open'
          : ''
    );

    // Section column visibility: use Auth.getUser().sections to decide
    // whether the current instructor can see any sections at all. Each
    // courseMember row now ships `section_name` directly from BE, so no
    // id → name lookup is needed for the cell value itself.
    const user = Auth.getUser() || {};
    const userSections = Array.isArray(user.sections) ? user.sections : [];
    const showSection = userSections.length > 0;

    return (
      <div>
        <Table>
        <thead>
          <TableHeadRow>
            <TableHeadCell>Name</TableHeadCell>
            <TableHeadCell>Email</TableHeadCell>
            {showSection && <TableHeadCell>Section</TableHeadCell>}
            <TableHeadCell withSelector>
              <SortableHeader
                type="button"
                onClick={this.handleTeamSortToggle}
                title={
                  teamSortDirection === 'asc'
                    ? 'Sort teams descending'
                    : teamSortDirection === 'desc'
                      ? 'Clear team sort'
                      : 'Sort teams ascending'
                }
              >
                <span>Team</span>
                <SortIconWrapper>
                  <SortChevron
                    direction="up"
                    active={teamSortDirection === 'asc'}
                  />
                  <SortChevron
                    direction="down"
                    active={teamSortDirection === 'desc'}
                  />
                </SortIconWrapper>
              </SortableHeader>
            </TableHeadCell>
            <TableHeadCell withSelector>
              <RoleHeaderContent>
                <span>Role</span>
                <RotateButton
                  type="button"
                  disabled={rotateDisabled}
                  spinning={rotatingRoles}
                  onClick={rotateDisabled ? undefined : this.handleRotateRoles}
                  title={anyRoleAssigned ? 'Rotate roles' : 'Assign a role first to enable rotation'}
                >
                  <RotateIconSvg />
                </RotateButton>
              </RoleHeaderContent>
            </TableHeadCell>
            <TableHeadCell>Registered</TableHeadCell>
            {
              surveys.map((survey, index) => (
                <TableHeadCell key={index}>{survey.name}</TableHeadCell>
              ))
            }
            <TableHeadCell withActions>Actions</TableHeadCell>
          </TableHeadRow>
        </thead>
        <tbody>
          {
            sortedTeamPlayers.map((teamPlayer, index) => {
              const currentTeam = availableTeams[' ' + Number(teamPlayer.team)];
              const teamName = currentTeam ? currentTeam : teamPlayer.team;

              // BE's instructor serializer puts the student's EMAIL in
              // courseMember.user; the legacy shape used username. Match
              // on either so the join survives either response shape.
              // Compare case-insensitively — BE emails come back
              // uppercased while teamPlayer.user.email is often mixed
              // case, which was breaking the join silently.
              const tpUsername = teamPlayer.user && teamPlayer.user.username
                ? String(teamPlayer.user.username).toLowerCase() : '';
              const tpEmail = teamPlayer.user && teamPlayer.user.email
                ? String(teamPlayer.user.email).toLowerCase() : '';
              const currentCourseMember = courseMembers.find(cm => {
                if (!cm || cm.user == null) return false;
                const cmUser = String(cm.user).toLowerCase();
                return cmUser === tpUsername || cmUser === tpEmail;
              });
              // Registered iff the student's subscription window hasn't
              // expired. current_subscription is the end date of their
              // active subscription — anything in the future means
              // they're paid/registered right now.
              const currentSubscription = currentCourseMember ? currentCourseMember.current_subscription : null;
              const subscriptionMs = currentSubscription ? Date.parse(currentSubscription) : NaN;
              const isRegistered = !isNaN(subscriptionMs) && subscriptionMs > Date.now();
              const registeredIconSrc = isRegistered ? CheckedIcon : UncheckedIcon;

              const activeRow = activeEditedRow === teamPlayer.id;

              let surveyProgressTexts = [];
              let surveyProgressIcons = [];
              surveys.forEach((survey, index) => {
                const teamPlayerFeedbacks = surveysFeedbacks[index].filter(surveysFeedback => surveysFeedback.giver === teamPlayer.user.id);

                surveyProgressTexts[index] = 'Not Started';
                surveyProgressIcons[index] = SurveyPogressNotStartedIcon;

                if (teamPlayerFeedbacks.length) {
                  if (teamPlayerFeedbacks.length === teamPlayerFeedbacks.filter(surveysFeedback => surveysFeedback.completed === true).length) {
                    surveyProgressTexts[index] = 'Completed';
                    surveyProgressIcons[index] = SurveyPogressCompletedIcon;
                  } else {
                    if (surveysStatuses[index] === 'Open') {
                      surveyProgressTexts[index] = 'In Progress';
                      surveyProgressIcons[index] = SurveyPogressInProgressIcon;
                    } else {
                      surveyProgressTexts[index] = 'Incomplete';
                      surveyProgressIcons[index] = SurveyPogressIncompleteIcon;
                    }
                  }
                }
              });

              const fullName = `${teamPlayer.user.first_name} ${teamPlayer.user.last_name}`;

              return (
                <TableRow key={index} activeRow={activeRow}>
                  <TableCell>
                    <NameCellContent>
                      <span>{fullName}</span>
                      {activeRow && currentCourseMember && !Auth.isAssistantOrCoInstructor() && (
                        <TrashButton
                          onClick={() => this.handleTrashClick(currentCourseMember.id, teamPlayer.id, fullName)}
                          title="Remove student from course"
                        >
                          <TrashIconSvg />
                        </TrashButton>
                      )}
                    </NameCellContent>
                  </TableCell>
                  <TableCell>{teamPlayer.user.email}</TableCell>
                  {showSection && (
                    <TableCell>
                      {currentCourseMember && currentCourseMember.section_name
                        ? currentCourseMember.section_name
                        : '---'}
                    </TableCell>
                  )}
                  <TableCell>
                    {
                      activeRow &&
                      <TeamRolesSelector
                        options={availableTeams}
                        selectedOptionId={activeEditedTeamId}
                        onSelectorChange={this.handleTeamSelectChange}
                      />
                    }
                    {
                      !activeRow &&
                      teamName
                    }
                  </TableCell>
                  <TableCell>
                    {
                      activeRow &&
                      <TeamRolesSelector
                        options={teamPlayerRoles}
                        selectedOptionId={activeEditedRole}
                        onSelectorChange={this.handleRoleSelectChange}
                      />
                    }
                    {
                      !activeRow &&
                      <RoleBadge role={teamPlayer.role}>{teamPlayerRoles[teamPlayer.role]}</RoleBadge>
                    }
                  </TableCell>
                  <TableCell>
                    <RegisteredIcond src={registeredIconSrc} />
                  </TableCell>
                  {
                    surveys.map((survey, index) => (
                      <TableCell key={index}>
                        <SurveyStatusWrapper>
                          <SurveyStatusIcon>
                            <img src={surveyProgressIcons[index]} alt="Survey Progress" />
                          </SurveyStatusIcon>
                          <SurveyProgressTextsWrapper>
                            <SurveyProgressText status={surveyProgressTexts[index]}>
                              {surveyProgressTexts[index]}
                            </SurveyProgressText>
                            <SurveyProgressStatusText status={surveysStatuses[index]}>
                              {surveysStatuses[index]}
                            </SurveyProgressStatusText>
                          </SurveyProgressTextsWrapper>
                        </SurveyStatusWrapper>
                      </TableCell>
                    ))
                  }
                  <TableCell withActions>
                    {
                      !activeRow &&
                      <TableButton onClick={() => this.handleTeamPlayerButtonClick(teamPlayer.id, teamPlayer.team, teamPlayer.role)}>
                        <EditButtonIcon src={EditIcon} />
                        <span>Edit</span>
                      </TableButton>
                    }
                    {
                      activeRow &&
                      <TableButton onClick={() => this.handleTeamPlayerButtonClick(0, 0, null)}>
                        <span>Cancel</span>
                      </TableButton>
                    }
                    {
                      (activeRow && editedRowChanged) &&
                      <TableButton saveButton onClick={() => this.handleSaveButtonClick(teamPlayer.id, activeEditedTeamId, activeEditedRole)}>
                        {
                          saveButtonLoading &&
                          <ButtonLoader>
                            <Loader type="ball-scale-ripple" active />
                          </ButtonLoader>
                        }
                        {
                          !saveButtonLoading &&
                          <span>Save</span>
                        }
                      </TableButton>
                    }
                  </TableCell>
                </TableRow>
              );
            })
          }
          {
            !sortedTeamPlayers.length &&
            <TableRow>
              <TableCell>Nothing found</TableCell>
            </TableRow>
          }
        </tbody>
        </Table>
        {memberToDelete && (
          <ConfirmOverlay onClick={this.handleCancelDelete}>
            <ConfirmModal onClick={e => e.stopPropagation()}>
              <ConfirmTitle>Are You Sure?</ConfirmTitle>
              <ConfirmMessage>
                Are you sure you want to remove <strong>{memberToDelete.name}</strong> from the course?
                Once this student is removed, they cannot be added back to the simulation.
              </ConfirmMessage>
              {deleteError && <ConfirmError>{deleteError}</ConfirmError>}
              <ConfirmActions>
                <ConfirmCancelButton onClick={this.handleCancelDelete} disabled={deleteLoading}>
                  Cancel
                </ConfirmCancelButton>
                <ConfirmProceedButton onClick={this.handleConfirmDelete} disabled={deleteLoading}>
                  {deleteLoading ? 'Removing...' : 'Remove Student'}
                </ConfirmProceedButton>
              </ConfirmActions>
            </ConfirmModal>
          </ConfirmOverlay>
        )}
      </div>
    );
  }
}

export default TeamsRolesTable;



// WEBPACK FOOTER //
// ./src/instructor/components/teams-roles/table.js